/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const contactNodes = Array.from(document.querySelectorAll('.hub-contacts'));
if (contactNodes.length) {
    import(/* webpackChunkName: "HubContacts" */ './components/HubContacts').then(({ default: HubContacts }) => {
        contactNodes.forEach((node) => render(<HubContacts {...parseDataToProps(node.dataset)} />, node));
    });
}
